// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Lecture } from './lecture';
import { Test } from './test';

/**
 * 
 * @export
 * @interface CourseLectureUnion
 */
export interface CourseLectureUnion {
    /**
     * 
     * @type {string}
     * @memberof CourseLectureUnion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLectureUnion
     */
    version: CourseLectureUnionVersionEnum;
    /**
     * 
     * @type {Lecture}
     * @memberof CourseLectureUnion
     */
    lecture: Lecture;
    /**
     * 
     * @type {Test}
     * @memberof CourseLectureUnion
     */
    test?: Test;
    /**
     * 
     * @type {number}
     * @memberof CourseLectureUnion
     */
    sort: number;
    /**
     * 
     * @type {string}
     * @memberof CourseLectureUnion
     */
    courseId: string;
    /**
     * 
     * @type {string}
     * @memberof CourseLectureUnion
     */
    parentId?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum CourseLectureUnionVersionEnum {
    V1 = 'v1',
    V2 = 'v2'
}



